import { useEffect, useState } from 'react';
import { getDispatchContext } from '../api/warehouseApi';
import { hasPermission } from '../utils/permissions';

export default function usePrincipalDispatch(branchId, user) {
  const allowed = Boolean(branchId && hasPermission(user, 'delivery_guide.transfer'));
  const scope = `${user?.id}:${user?.selectedCompanyId}:${branchId}:${allowed}`;
  const [state, setState] = useState({});
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    if (allowed) {
      setState({ scope, loading: true });
      getDispatchContext(branchId)
        .then(data => { if (active) setState({ scope, eligible: data.eligible === true,
          origins: data.origins, defaultOriginBranchId: data.defaultOriginBranchId, loading: false }); })
        .catch(() => { if (active) setState({ scope, error: 'No se pudo verificar la sucursal de despacho.', loading: false }); });
    }
    return () => { active = false; };
  }, [branchId, allowed, scope, attempt]);

  return {
    ...(allowed && state.scope === scope ? state : { eligible: false, loading: allowed }),
    retry: () => setAttempt(value => value + 1),
  };
}
